import React, { useEffect, useRef, useState } from "react";
import paymentfailed from '../../Assets/Images/Payment-Failed.jpg';
import googleicon from '../../Assets/Images/googleicon.png';
import stripeicon from '../../Assets/Images/stripeImg.png';
import paymentsuccessIcon from '../../Assets/Images/paymentsuccess.png';
import { formatUSNumber, MakeAxiosRequest } from "../../utils/handler";
import { useForm, Controller } from "react-hook-form";
import { Link, useNavigate, useParams } from 'react-router-dom';
import StripeContainer from './StripeContainer';
import { Modal, Button } from 'react-bootstrap';
function ErrorPayment() {
    const params = useParams();
    
     
    
return (
    <section className="wrapper-body payment-body ">
        <div className="container h-100">
            <div className="row h-100 align-items-center">
                <div className="col-lg-5 col-md-7 mx-auto">
                    <div className="card payment-failed">
                        <div className="card-body payment_body  py-3">
                            <div className="text-center">
                                <img src={paymentfailed} alt="payment failed" className="img-fluid" />
                                <h2 className=" fw-e-bold" >Payment Failed</h2>
                                <p>Could not complete payment process</p>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>    

    )
}

export default ErrorPayment